module.exports = __webpack_public_path__ + "img/360logo-w.58a9ee2f.png";